<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-01 16:00:30
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="card journalism-card">
    <div class="card-header">
      <div>新闻公告</div>
      <div class="more" v-if="newsList.length > 0 && newsList[0].docsubject.moreUrl" @click="handleMoreClick">更多</div>
    </div>
    <div v-if="errorCode === '10044'" class="error-message">
      {{ errorMessage }}
    </div>
    <div v-else class="journalism-scroll">
      <div class="info" v-for="(item,index) in newsList" :key="index" @click="handleItemClick(item)" @mouseenter="handleItemHover(item, $event)" @mouseleave="handleItemLeave($event)">
        <div class="tips">{{ item.title || item.subject || item.docsubject?.name }}</div>
        <div>{{ item.doclastmoddate || item.publishTime || item.date }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      newsList: [],
      errorCode: null, // 错误码
      errorMessage: '' // 错误信息
    }
  },
  computed: {},
  created () {
    this.getNewsList()
  },
  methods: {
    // 更多点击：先通过第一条数据的 link 存储 token，再跳转 moreUrl（因对方禁止 iframe，改用新窗口）
    handleMoreClick () {
      const firstItem = this.newsList[0]
      const listUrl = firstItem?.docsubject?.moreUrl
      if (!listUrl) return
      const doNavigate = (targetUrl) => {
        if (this.isMobile()) {
          window.location.href = targetUrl
        } else {
          window.open(targetUrl, '_blank')
        }
      }

      const link = firstItem?.docsubject && (this.isMobile() ? firstItem.docsubject.mobilelink : firstItem.docsubject.link)
      if (link) {
        this.$request.get(`/sso/oa/user/mapping/ssoLogin/getToken`).then(res => {
          const { code, data } = res.data
          if (code === 'OK') {
            const tokenUrl = `${link}&ssoToken=${data}`
            const win = window.open(tokenUrl, 'journalismMore')
            if (win) {
              setTimeout(() => {
                if (!win.closed) {
                  win.location.href = listUrl
                } else {
                  doNavigate(listUrl)
                }
              }, 100)
            } else {
              doNavigate(listUrl)
            }
          } else {
            doNavigate(listUrl)
          }
        }).catch(() => {
          doNavigate(listUrl)
        })
      } else {
        doNavigate(listUrl)
      }
    },
    // 获取新闻列表
    getNewsList () {
      this.$request.post('/sso/workItem/findNews').then(res => {
        const { code, data, message } = res.data
        // 处理错误码 10044
        if (code === '10044') {
          this.errorCode = code
          this.errorMessage = message || '暂无数据'
          this.newsList = []
          return
        }

        if (code === 'OK') {
          this.errorCode = null
          this.errorMessage = ''
          // 根据实际返回的数据结构调整，可能是 data.list 或 data.records 或 data 数组
          this.newsList = data?.list || data?.records || (Array.isArray(data) ? data : []) || []
          // 限制显示数量为8条
          if (this.newsList.length > 8) {
            this.newsList = this.newsList.slice(0, 8)
          }
        }
      }).catch(err => {
        console.error('获取新闻列表失败:', err)
        this.errorCode = 'error'
        this.errorMessage = '加载失败，请稍后重试'
        this.newsList = []
      })
    },
    // 判断是否为移动端
    isMobile () {
      const ua = navigator.userAgent.toLowerCase()
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
      return mobileRegex.test(ua) || window.innerWidth <= 768
    },
    // 点击事件处理
    handleItemClick (item) {
      if (!item.docsubject) {
        return
      }
      this.$request.get(`/sso/oa/user/mapping/ssoLogin/getToken`).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          const link = this.isMobile() ? item.docsubject.mobilelink : item.docsubject.link
          if (link) {
            if (this.isMobile()) {
              // 移动端：当前窗口打开
              window.location.href = `${link}&ssoToken=${data}`
            } else {
              // PC端：新窗口打开
              window.open(`${link}&ssoToken=${data}`, '_blank')
            }
          }
          console.log(data)
        }
      }).catch(err => {
        console.error(err)
      })
      // const link = this.isMobile() ? item.docsubject.mobilelink : item.docsubject.link
      // if (link) {
      //   if (this.isMobile()) {
      //     // 移动端：当前窗口打开
      //     window.location.href = link
      //   } else {
      //     // PC端：新窗口打开
      //     window.open(link, '_blank')
      //   }
      // }
    },
    // hover 事件处理
    handleItemHover (item, event) {
      // 可以在这里添加 hover 时的逻辑，比如显示提示信息等
      event.currentTarget.style.cursor = 'pointer'
    },
    // 鼠标离开事件处理
    handleItemLeave (event) {
      // 恢复默认样式
      event.currentTarget.style.cursor = 'default'
    }
  }
}
</script>

<style scoped lang="less">
@import url("../index.modules.less");

.journalism-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.journalism-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
  }
}

.card {
  position: relative;

  .more {
    cursor: pointer;
  }

  .error-message {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    min-height: 1.4rem;
    color: #999;
    font-size: 17px;
    text-align: center;
    padding: 20px;
  }

  .info {
    font-size: 17px;
    line-height: 1.45;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #f5f5f5;
      border-radius: 4px;
    }

    > div:first-child {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0; // 确保 flex 子元素可以收缩
      margin-right: 12px;
    }

    > div:last-child {
      flex-shrink: 0; // 日期部分不收缩
      white-space: nowrap;
    }
  }
}
</style>
